 <template>
    <section class="container margin-both-xl" v-if="data && data.content">
        <HtmlContent class="no-padding" :html="updatedContent(data.content)" />
    </section>
</template>

<script>
import HtmlContent from '@/components/elements/HtmlContent'
import { mapGetters } from 'vuex';

export default {
    props : ['data'],
    components: {
        HtmlContent
    },
    computed:{
        ...mapGetters([
        	'getOptions',
        ]),
        extendedCookies(){
            return this.getOptions.use_cookiesinformationcom
        }       
    },

    methods:{
      updatedContent(content){
        if(this.extendedCookies){
          //https://www.regexpal.com/99829
          let newContent = content
          const regEx = /(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/g
          const match = newContent.match(regEx);
          if(match && match.length){
            match.forEach(e => {
              //avoid repalce in empty src just in case
              if( e && !~e.indexOf('src=""') ){
                //newContent = e.replace('src', 'data-category-consent="cookie_cat_statistic" data-consent-src')
                let updatedIframe = e.replace('src', 'data-category-consent="cookie_cat_statistic" data-consent-src')
                newContent = newContent.replace(e, updatedIframe)
              }
            });
          }
          return newContent
        }else{
          return content
        }
      }
    } 
}
</script>

<style lang="scss">


.module-content_block{

    .html-content{
        max-width: 800px;
        margin-right: auto;
        margin-left: auto;
        
    }
}
</style>